import get from 'lodash.get';
import template from 'lodash.template';

var templateCache = {};
var compile = function compile(templateString, variables) {
  if (variables === void 0) {
    variables = {};
  }
  if (templateString === '') {
    console.warn('template failed');
    return null;
  }
  if (!templateCache[templateString]) {
    templateCache[templateString] = template(templateString);
  }
  var compiled = templateCache[templateString];
  return compiled(variables);
};
var getTemplateOrDefault = function getTemplateOrDefault(templates, defaults, label) {
  return get(templates, label, get(defaults, label));
};

export { compile, getTemplateOrDefault };
//# sourceMappingURL=index.js.map
